import { z } from 'zod';
import { HttpErrorResponse } from '../common/validation-error';
const CompanyId = z.coerce.number().int().positive();
const CohortId = z.coerce.number().int().positive();
const CompanyCohortParams = z.object({
    companyId: CompanyId,
    cohortId: CohortId,
});
const MessageResponse = z.object({ message: z.string() });
const IsoDate = z.string().datetime({ offset: true });
export const addCohortRoute = {
    version: 1,
    method: 'POST',
    path: '/admin/companies/{companyId}/cohorts',
    name: 'add-cohort',
    request: {
        params: z.object({ companyId: CompanyId }),
        body: z.object({
            startDate: z.string().min(1),
            endDate: z.string().min(1),
            kickOffTimes: z.array(IsoDate),
            officeHourTimes: z.array(IsoDate),
        }),
    },
    responses: {
        200: MessageResponse,
        400: HttpErrorResponse,
        404: HttpErrorResponse,
    },
};
export const inviteLearnersToCohortRoute = {
    version: 1,
    method: 'POST',
    path: '/admin/companies/{companyId}/cohort/{cohortId}/invite',
    name: 'invite-learners-to-cohort',
    request: {
        params: CompanyCohortParams,
        body: z.object({ learnerIds: z.array(z.number().int().positive()).min(1) }),
    },
    responses: {
        200: MessageResponse,
        400: HttpErrorResponse,
        404: HttpErrorResponse,
    },
};
export const assignLearnersToCohortMentorRoute = {
    version: 1,
    method: 'POST',
    path: '/admin/companies/{companyId}/cohort/{cohortId}/assign-mentor',
    name: 'assign-learners-to-cohort-mentor',
    request: {
        params: CompanyCohortParams,
        body: z.object({
            assignments: z
                .array(z.object({
                mentorProfileId: z.number().int().positive(),
                firstOfficeHourTimestamp: IsoDate,
                cohortInviteIds: z.array(z.number().int().positive()).min(1),
            }))
                .min(1),
        }),
    },
    responses: {
        200: MessageResponse,
        400: HttpErrorResponse,
        404: HttpErrorResponse,
    },
};
export const updateMentorCohortAvailabilityRoute = {
    version: 1,
    method: 'POST',
    path: '/admin/companies/{companyId}/cohort/{cohortId}/mentor/availability',
    name: 'update-mentor-cohort-availability',
    request: {
        params: CompanyCohortParams,
        body: z.object({
            availabilities: z.array(z.object({
                companyMentorId: z.number().int().positive().nullable(),
                officeHourTimes: z.array(z.string()),
            })),
        }),
    },
    responses: {
        200: MessageResponse,
        400: HttpErrorResponse,
        404: HttpErrorResponse,
    },
};
export const addAssessmentTestCohortRoute = {
    version: 1,
    method: 'POST',
    path: '/admin/companies/{companyId}/tests/cohorts',
    name: 'add-assessment-test-cohort',
    request: {
        params: z.object({ companyId: CompanyId }),
        body: z.object({ name: z.string().min(1) }),
    },
    responses: {
        200: MessageResponse,
        400: HttpErrorResponse,
        404: HttpErrorResponse,
    },
};
export const inviteUsersToAssessmentTestsRoute = {
    version: 1,
    method: 'POST',
    path: '/admin/companies/{companyId}/tests/invite',
    name: 'invite-users-to-assessment-tests',
    request: {
        params: z.object({ companyId: CompanyId }),
        body: z.object({
            cohortId: z.number().int().positive(),
            testAssignments: z
                .array(z.object({
                name: z.string().min(1),
                email: z.string().email(),
                assessmentTestId: z.number().int().positive(),
            }))
                .min(1),
        }),
    },
    responses: {
        200: MessageResponse,
        400: HttpErrorResponse,
        404: HttpErrorResponse,
    },
};
